import { TagSelection } from 'features/TagSelection';

const TagSelectionPage = () => <TagSelection />;

export default TagSelectionPage;
